import React, { useContext, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { DF_CO0002Context } from "../context"
import { Modal, Row } from "reactstrap"
import BizinBackend from "../../../helpers/bizin_helper"
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken"
import { fnReplaceParamKeyWithFilteredValue } from "../../../helpers/functions"
import TableSimple from "../../../components/Dynamic/TableSimple"
import ModalIframePage from "../../../components/Common/ModalIframePage"

const PROC_NAME = "FRONT_Workspace_DF_CO0002_Tabela_Grid_V16"

export default function GridBody() {
  const {
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    inputGlobalSearchValue,
    setFilteredData,
    userProfile
  } = useContext(DF_CO0002Context)

  const { access_token } = useSelector((state) => ({
    access_token: state.login.user?.access_token,
  }))
  const csrfToken = useGetCsrfToken()

  const [gridData, setGridData] = useState([])
  const [dataVersion, setDataVersion] = useState(0)
  const [triggerType, setTriggerType] = useState('')
  const [openModalVisualization, setOpenModalVisualization] = useState(false)

  const handleTriggers = (trigger) => {
    setOpenModalVisualization(true)
    setTriggerType(trigger)
  }

  return (
    <React.Fragment>
      <Row>
        <TableSimple
          dataKey={"ID_Arquivo"}
          procName={PROC_NAME}
          procParams={`[
            ${userProfile.ID_Usuario},
            "pt-BR",
            1,
            9999,
            "NF",
            "<#Filtro_Data_Inicio#>",
            "<#Filtro_Data_Termino#>",
            "<#Filtro_ID_Empresa_Origem#>",
            "<#Filtro_ID_Planta_Origem#>",
            "<#Filtro_ID_Empresa_Destino#>",
            "<#Filtro_ID_Planta_Destino#>",
            "<#Filtro_Numero_Documento_Nota#>",
            "<#Filtro_Status_Documento#>",
            "<#Filtro_Status_Validacao#>",
            "<#Filtro_Status_Integracao#>",
            "<#Filtro_Status_Cotacao#>",
            "<#Filtro_Status_Leitura#>",
            "<#Filtro_Status_Aceite#>",
            "<#Filtro_ID_Categorias#>",
            "<#Filtro_Documento_Relacionado_Nota#>",
            "<#Filtro_PreFiltro#>"
          ]`}
          columnsList={
            [
              {
                "field":"Status",
                "header":"Status",
                "width": '5%',
                "hasImage": true,
              },
              {
                "field":"Processamento",
                "header":"Data Process.",
                "sort": true
              },
              {
                "field":"Nota_Fiscal",
                "header":"NF",
                "sort": true
              },
              {
                "field":"Documentos_Relacionados",
                "header":"Pedido",
                "sort": true
              },
              {
                "field":"Fornecedor",
                "header":"Emissor",
                "hasImage": true,
                "sort": true
              },
              {
                "field":"Revenda",
                "header":"Destinatário",
                "hasImage": true,
                "sort": true
              },
              {
                "field":"Local_Entrega",
                "header":"Local de Entrega",
                "hasImage": true,
                "sort": true
              },
              {
                "field":"Valor",
                "header":"Valor NF",
                "sort": true
              },
              {
                "field":"Coluna_Data_Agendamento",
                "header":"Data Ag."
              },
              {
                "field":"Coluna_Funcoes",
                "header":"",
                "width": '5%',
                "hasImage": true,
                "Export": false
              },
              ]
          }
          inputSearchValue={inputGlobalSearchValue}
          callbackTriggers={handleTriggers}
          enableDataSharing={true}
          onFilteredDataChange={setFilteredData}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          paramsOnFilter={paramsOnFilter}
          enableMinHeight={true}
        />

        <ModalIframePage
          openModal={openModalVisualization}
          onClosed={(isReloadPage) => {
            if(isReloadPage) setTriggerOnFilter(true)
            setOpenModalVisualization(false)
          }}
          triggerType={triggerType}
        />

      </Row>
    </React.Fragment>
  )
}
